import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Learn from "./pages/Learn";
import LearnCourse from "./pages/LearnCourse";
import Academy from "./pages/Academy";
import LegacyAcademy from "./pages/LegacyAcademy";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ExtraSection from "./components/ExtraSection";
import ScrollToTop from "./components/scroll/ScrollToTop"; 
import CookieBanner from "./components/cookies/CookieBanner";
import FloatingCoffeeButton from "./components/FloatingCoffeeButton";
import CookiesPolicy from "./pages/CookiesPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalNotice from "./pages/LegalNotice"; 
import BlogPost from "./components/blogPosts/BlogPost";
import BugDictionary from "./pages/BugDictionary";
import TestHub from "./pages/TestsHub";
import AIHub from "./pages/AIHub";
import Dashboard from "./pages/Dashboard";
import RetosHome from "./pages/retos/RetosHome";
import Reto1 from "./pages/retos/Reto1";
import Reto2 from "./pages/retos/Reto2";
import Reto3 from "./pages/retos/Reto3";
import Settings from "./pages/Settings";
import RoadmapPage from "./pages/rutaDeEstudio/RoadmapPage";
import RoadmapTopic from "./pages/rutaDeEstudio/RoadmapTopic";
import RoadmapLayout from "./pages/rutaDeEstudio/RoadmapLayout";
import { LanguageProvider } from "./i18n";
import RequireAuth from "./components/auth/RequireAuth";
import "./styles/styles.css";

function App() {
  return (
    <LanguageProvider>
      <div className="app-container">
        <ScrollToTop /> 
        <Header />
        <CookieBanner />
        <main className="main-content" style={{ marginTop: 'calc(var(--header-height))' }}>
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/inicio" element={<Navigate to="/" replace />} />
              <Route path="/diego-sanchez-martin" element={<Navigate to="/sobre-mi" replace />} />
              <Route path="/sobre-mi" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/bugs" element={<BugDictionary />} />
              <Route path="/bug-dictionary" element={<Navigate to="/bugs" replace />} />
              <Route path="/ai" element={<Navigate to="/ai-hub" replace />} />
              <Route path="/ai-hub" element={<AIHub />} />
              <Route path="/tests" element={<Navigate to="/test-hub" replace />} />
              <Route path="/test-hub" element={<TestHub />} />
              <Route path="/learn" element={<Navigate to="/aprende" replace />} />
              <Route path="/aprende" element={<Learn />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/academy-legacy" element={<LegacyAcademy />} />
              <Route element={<RequireAuth />}>
                <Route path="/learn/:courseId" element={<LearnCourse />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/retos" element={<RetosHome />} />
                <Route path="/retos/reto1" element={<Reto1 />} />
                <Route path="/retos/reto2" element={<Reto2 />} />
                <Route path="/retos/reto3" element={<Reto3 />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/roadmap" element={<RoadmapLayout />}>
                  <Route index element={<RoadmapPage />} />
                  <Route path=":topic" element={<RoadmapTopic />} />
                </Route>
              </Route>
              <Route path="/contact" element={<Navigate to="/contacto" replace />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/cookies-policy" element={<CookiesPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/legal-notice" element={<LegalNotice />} />
              <Route path="/blog/:id" element={<BlogPost />} /> 
              <Route path="/login" element={<Login />} />
            </Routes>
          </div>
        </main>
        <ExtraSection />
        <Footer />
        <FloatingCoffeeButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
